module.exports = __webpack_public_path__ + "img/stamp_received@2x.5583c348.png";